import { Typography } from '@mui/material';
import { LocationData } from '../utils/inventory';

interface Props {
    locationData: LocationData;
}

export default function ItemLocationBreakdown({ locationData }: Props) {
    const { storageLocations, events, total } = locationData;
    const totalStorage = storageLocations.reduce((s, x) => s + x.quantity, 0);

    if (total === 0) {
        return (
            <Typography variant="body2" color="text.secondary">
                No inventory
            </Typography>
        );
    }

    if (events.length === 0 && totalStorage > 0 && storageLocations.length === 1) {
        return (
            <Typography variant="body2" color="text.secondary">
                All at {storageLocations[0].name}
            </Typography>
        );
    }

    if (events.length === 1 && totalStorage === 0) {
        return (
            <Typography variant="body2" color="text.secondary">
                {events[0].quantity} at {events[0].eventName}
            </Typography>
        );
    }

    const storageSummary = totalStorage > 0 ? storageLocations.map(s => `${s.quantity} at ${s.name}`).join(', ') : '';
    const eventSummary = events.length > 0 ? `${events.length} event${events.length > 1 ? 's' : ''}` : '';
    const summaryText = [storageSummary, eventSummary].filter(Boolean).join(', ');

    return (
        <Typography variant="body2" color="text.secondary">
            {summaryText}
        </Typography>
    );
}
